import React, { useEffect, useState } from "react";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { withNamespaces } from "react-i18next";
import { Icon } from "semantic-ui-react";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import ImageUpload from "../Components/ImageUpload";
import { useCallback } from "react";
import { Services } from "../../../repositories/clients/Services";
import Axios from "axios";
import { connect } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import Loader from "../../Global/Loader";
import xls from "../../../resources/excel.svg"
import createModal from "../Components/ModalV2";
import { schemaFull } from "./schemas/purchaseOrder.schema";

const filesAccepted = [
  "application/vnd.ms-excel",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".xls",
  ".xlsm",
  ".xlsx",

  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".doc",
  ".docx",

  "application/pdf",
  ".pdf",

  "image/png",
  "image/jpeg",
  ".png",
  ".jpg",
  ".jpeg",
];


const maxSizeFile = "10MB";

function LoadPO(params) {
  const [entities] = useState(params.clients);
  const [file, setFile] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [validating, setValidating] = useState(false);
  const [hiddenLoadButton, setHiddenLoadButton] = useState(true);
  const [catalogEntities, setCatalogEntities] = useState([]);
  const [loadPos, setLoadPos] = useState([]);
  const [codeEP, setCodeEP] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [loader, setLoader] = useState(true);
  const [modalAlert, setModalAlert] = useState(false);
  const [uploadDocPo, setUploadDocPo] = useState(false);
  const [modalType, setModalType] = useState("success");
  const [modalMessage, setModalMessage] = useState("");

  function callFile(dataFile) {
    // if (dataFile?.fileExtension.indexOf(filesAccepted) > -1 && dataFile?.fileSize <= maxSizeFile) {
    if (dataFile) {
      setFile(dataFile.file);
    } else {
      setFile([]);
      setHiddenLoadButton(true);
      setValidating(false);
    }
  }


  const getData = useCallback(async () => {
    if (!file) return;

    setValidating(true);
    setLoader(false)

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("selectedValue", selectedValue);

      const url = `${Services.PURCHASE_ORDER.path}purchaseOrder/extract-po`;

      const res = await Axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 10 * 60 * 1000,
      });

      uploadPos([res.data.data])
    } catch (error) {
      console.log("🚀 ~ LoadPO ~ error:", error)
      setModalAlert(true)
      setModalMessage(params.t("po_management_upload_po_ia_error"));
      setModalType('error')
      setLoader(true)
    }
  }, [file]);



  const catEntities = useCallback(async () => {
    let body = { entities: entities };

    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/entities`;
      let res = await Axios.post(url, body);
      setCatalogEntities(res.data.data);
    } catch (error) {
      console.log("🚀 ~ catEntities ~ error:", error.message);
    }
  }, []);

  const uploadPos = useCallback(async (po) => {
    try {

      if (po[0].PO) {
        // let poNumber = po[0].PO.PONumber;
        // const randomSuffix = Math.floor(Math.random() * 100000);

        // po[0].PO.PONumber = `${poNumber}-${randomSuffix}`;
        po[0].PO.incoterms = po[0].PO.incoterms ? po[0].PO.incoterms : null;
      }

      for (let i = 0; i < po.length; i++) {
        const { error } = schemaFull.validate(po[i], { abortEarly: false });

        if (error) {
          console.error("❌ Error de validación en PO:", po[i], error.details);

          setModalAlert(true)
          setModalMessage(`Error de validación en PO:  \n` + error.details.map(d => d.message).join("\n"));
          setModalType('error')
          setValidating(false)
          setLoader(true)

          throw new Error(
            `La PO en la posición ${i + 1} tiene errores de validación: \n` +
            error.details.map(d => d.message).join("\n")
          );
        }

        // po[i].PO.POCreationDate = new Date().toISOString();
      }

      let body = { data: [...po], customerCode: codeEP };
      let config = {
        method: "post",
        url: `${Services.PROCESS_JOBS.path}api/v1/process/po`,
        headers: {
          apikey: "19c401a6-5407-4eaf-92a2-344ea695cd8e",
          "Content-Type": "application/json",
        },
        data: body,
        timeout: 120000,
      };

      Axios.request(config)
        .then((response) => {
          if (response.data.poExist.length !== 0) {
            setUploadDocPo(true)
            setModalMessage(
              <>
                {/* <p>{params.t("po_management_upload_loaded_successfully")}</p> */}
                <p>{params.t("po_management_upload_no_loaded")}</p>
                <p>{response.data.poExist.join(", ")}</p>
              </>
            );
            setLoader(true)
            setModalType('success')

            // setAction(() => () => params.history.push("/po-management"));
          } else {
            setUploadDocPo(true)
            setModalMessage(`PO ${body.data[0].PO.PONumber} ` + params.t("po_management_upload_loaded_successfully_ia"));
            setModalType('success')
            setLoader(true)
          }
        })
        .catch((error) => {
          console.log("🚀 ~ LoadPO ~ error:", error)
          setValidating(false);
          setLoader(true)

          setLoader(true);
          if (error.response) {
            let message =
              error.response.data.data == "All POs already exist in the DB"
                ? params.t("po_management_upload_doc_po_exist_ia")
                : error.response.data.data.replace("PO() PO validate :", "");

            setModalAlert(true)
            setModalMessage(`Error: ${message}`);
            setModalType('error')
          } else if (error.request) {
            // La petición fue realizada pero no se recibió respuesta

            setModalAlert(true)
            setModalMessage(`Error en la petición: ${error.request}`);
            setModalType('error')
          } else {
            // Algo ocurrió al configurar la petición
            console.error("Error:", error.message);
          }
        });
    } catch (error) {
      console.log("🚀 ~ uploadPos ~ error:", error);
      setLoader(true)
    }
  }, [loadPos, codeEP]);

  const handleChange = (data) => {
    setCodeEP(data ? data.CodeEP : null);
    setSelectedValue(data ? data.id : null);
  };

  useEffect(() => {
    catEntities();
  }, []);

  return (
    <ContentWrapper>
      <Loader hidden={loader} />
      <div className="content-heading">
        <span className="icon-po-management icon-header" />
        {params.t("po_management_upload_ia_tittle")}
        <div className="euro-return-tittle">
          <Icon.Group size="large">
            <Icon
              name="angle left"
              className="_btnBack"
              size="big"
              onClick={() => params.history.push("/po-management")}
            />
          </Icon.Group>
          <span className="label-back" onClick={() => params.history.push("/po-management")}>
            {params.t("back")}
          </span>
        </div>
      </div>
      <Card className="myCard">
        <CardBody>
          <Col xs={12} sm={10} md={8} lg={6} className="mr-auto ml-auto">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-11 align-items-center mr-auto ml-auto pt-4 mb-5">
              <span className="label-euro bold mr-2">
                {params.t("po_management_select_company")}
              </span>
              <Autocomplete
                options={catalogEntities}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                renderInput={(params) => (
                  <TextField {...params} variant="standard" />
                )}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                filterOptions={(options, { inputValue }) => {
                  if (inputValue.length < 3) {
                    return options;
                  }
                  return options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
                // options={catalogs && catalogs[item.id] ? catalogs[item.id] : []}
                onChange={(evt, data) => {
                  handleChange(data);
                }}
                // onChange={handleChange}
                renderOption={(props, option) => (
                  <li {...props} key={option.id || option.CodeEP}>
                    {option.label}
                  </li>
                )}
                ListboxProps={{
                  sx: {
                    fontSize: 12,
                    color: "#000",
                  },
                  style: {
                    maxHeight: 160, // Aproximadamente 6 opciones visibles
                  },
                }}
                sx={{
                  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                    fontSize: 12,
                    color: "#000",
                  },
                }}
                clearOnEscape
                noOptionsText={params.t("po_management_select_no_options")}
              />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-11 align-items-center mr-auto ml-auto pb-5">
              <span className="label-euro bold mr-2">
                {params.t("po_management_upload_file")}
              </span>
              <ImageUpload
                callFile={callFile}
                lng={params.t}
                filesAccepted={filesAccepted}
                maxSizeFile={maxSizeFile}
                fileValidateTypeLabelExpectedTypes={params.t("po_management_upload_file_only_ia")}
                labelMaxFileSizeExceeded={params.t("po_management_upload_file_is_too_large_ia")}
                labelMaxFileSize={params.t("po_management_upload_file_maximun_file_size_ia")}
              />
            </div>
            <div className="d-flex justify-content-center">
              <Button
                color="primary"
                onClick={getData}
                hidden={
                  file.length !== 0 && selectedValue && hiddenLoadButton
                    ? false
                    : true
                }
                disabled={validating}
              >
                <span className="icon-ia-azul icon-button-add" />
                {params.t("po_management_upload_ia")}
              </Button>

              <Button
                color="primary"
                onClick={uploadPos}
                hidden={
                  hiddenLoadButton || !(file.length !== 0 && selectedValue)
                }
                disabled={!validating}
              >
                {params.t("po_management_upload_doc_upload")}
                <span className="icon-ia-azul icon-button-add" />
                {params.t("po_management_upload_ia")}
              </Button>
            </div>
          </Col>
        </CardBody>
      </Card>


      {createModal({
        isModalOpen: modalAlert,
        titleModal: modalType !== 'error' ? 'Success' : 'Error',
        type: modalType,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p style={{ whiteSpace: "pre-line" }}>{modalMessage}</p>
              {/* <p>{modalMessage}</p> */}
            </div>
          </>
        ),
        buttons: [
          {
            text: "Ok",
            onClick: () => setModalAlert(false),
            type: "primary",
          }
        ],
        onCancel: () => setModalAlert(false),
      })}
      {createModal({
        isModalOpen: uploadDocPo,
        titleModal: modalType !== 'error' ? 'Success' : 'Error',
        type: modalType,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{modalMessage}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: "Ok",
            onClick: () => params.history.push("/po-management"),
            type: "primary",
          }
        ],
        onCancel: () => params.history.push("/po-management"),
      })}
    </ContentWrapper>
  );
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
export default withNamespaces()(connect(mapStateToProps)(withRouter(LoadPO)));
